"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Paste;

var _Paste = require("@adobe/react-spectrum-workflow/dist/Paste");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Paste(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Paste.A4uPaste, null));
}